import { render, staticRenderFns } from "./certificateStudent.vue?vue&type=template&id=c7819828"
import script from "./certificateStudent.vue?vue&type=script&lang=js"
export * from "./certificateStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports